<template>
  <div>
    <h4>
      <span class="badge badge-secondary">{{ type }}</span>
    </h4>
    <h1>{{ name[0] || "TITLE UNKNOWN" }}</h1>
    <div v-if="name.length > 1">
      <b>Alternative titles:</b>
      <ul v-for="(alt_name, index) in name">
        <li v-if="index >= 1">{{ alt_name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportTitle",
  props: {
    type: String,
    name: Array,
  },
};
</script>
